import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { SelectBusinessCore } from "../../../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { SelectProject } from "../../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { FileInput } from "../../../../../theme/Component/FileInput";
import useModal, { MODAL_LG } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectSupplierPaymentTypeConstants } from "../../UBLInvoiceSupplier/Component/SelectSupplierPaymentTypeConstants";
import { SelectAccountantConceptCatalogForSupplierInvoice } from "../SelectAccountantConceptCatalogForSupplierInvoice";
import { useUBLInvoiceActions } from "../hooks/useUBLInvoiceActions";

interface Props {
    _onChange2?: Function;
}

export const CreateUBLInvoiceSupplier = ({ _onChange2 }: Props) => {
    const { instance, bean, setBean, lista, setLista, isMissing, validateForm, isRequired, addRequiredFields } = useDataBean(_UBLInvoice);
    const modalForm = useModal("Crear Factura de Proveedor", MODAL_LG);

    useEffect(() => {
        const requiredFields = [
            "PaymentType",
            "IDAccountSupplier",
            "AccountantDate",
            "IDThirdBankingAccount",
            "IDAccountantConcept",
            "IssueDate",
            ...(bean.PaymentType === 18 ? ["IDBusinessCore", "IDProject"] : []),
        ];

        addRequiredFields(requiredFields);
    }, [bean.PaymentType]);

    useEffect(() => {
        return () => setBean({});
    }, []);

    const openCreateModal = () => {
        setBean({
            IsDocumentSupport: false,
            IDAccountantConcept: null,
        });
        modalForm.open("Crear Factura de Proveedor");
    };

    const openEditModal = () => {
        modalForm.open("Editar Factura de Proveedor");
    };

    const setInvoiceResponse = (invoice: any) => {
        setBean(invoice);
        setLista([{ DataBeanProperties: invoice }]);
        _onChange2?.(invoice);
    };

    const generate = () => {
        instance.createPurchaseUBLInvoice(
            bean.PaymentType,
            bean.AccountantDate,
            bean.IDAccountSupplier,
            bean.IDThirdBankingAccount,
            bean.OdIDocument,
            bean.IDAccountantConcept,
            bean.InvoiceID,
            bean.IsDocumentSupport,
            bean.IssueDate,
            bean.Media,
            bean.MediaContext,
            _single.getAccountID(),
            bean.Observations,
            bean.IDBusinessCore,
            bean.IDProject
        ).then((resp: any) => {
            setInvoiceResponse(resp);
            modalForm.close();
        }).catch((err: any) => toast.error(err));
    };

    const updateUBL = () => {
        if (bean.ApplyPrepaidValue) {
            if (!bean.PrepaidIDAccountantStr || bean.PrepaidIDAccountantStr.trim() === "") {
                toast.error("Debe seleccionar la cuenta contable del anticipo.");
                return;
            }
            if (!bean.PrepaidPayment || isNaN(bean.PrepaidPayment) || bean.PrepaidPayment <= 0) {
                toast.error("Debe ingresar un valor valido del anticipo.");
                return;
            }
        }

        instance.updateUBLInvoice(bean).then((resp: any) => {
            setInvoiceResponse(resp);
            modalForm.close();
        }).catch((err: any) => console.log(err));
    };

    const validateData = () => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }

        if (bean.IDUBLInvoice) {
            updateUBL();
        } else {
            generate();
        }
    };

    const formUBL = () => (
        <div className="row">
            <div className="col-md-6">
                <label className={`${isMissing("PaymentType") ? "has-error" : ""}`}>Tipo de Pago {isRequired("PaymentType") ? <span className="text-danger">*</span> : ""}</label>
                <SelectSupplierPaymentTypeConstants idSelector={bean.PaymentType} onChange={(e) => { setBean({ ...bean, PaymentType: e, IDBusinessCore: null, IDProject: null }) }} label=" " />
            </div>

            <div className="col-md-6">
                <label className={`${isMissing("AccountantDate") ? "has-error" : ""}`}>Fecha de registro contable {isRequired("AccountantDate") ? <span className="text-danger">*</span> : ""}</label>
                <InputDate label=" " name="date" value={bean.AccountantDate} setDate={(e) => { setBean({ ...bean, AccountantDate: e }) }} />
            </div>

            {bean.PaymentType === 18 &&
                <>
                    <div className="col-md-6">
                        <label className={`${isMissing("IDProject") ? "has-error" : ""}`}>Proyecto {isRequired("IDProject") ? <span className="text-danger">*</span> : ""}</label>
                        <SelectProject
                            label=" "
                            idSelector={bean.IDProject}
                            onChange={(value) => {
                                if (!value) {
                                    setBean({ ...bean, IDProject: null, IDBusinessCore: null });
                                    return;
                                }

                                const { IDProject, IDBusinessCore } = value;
                                setBean({
                                    ...bean,
                                    IDProject: IDProject ?? null,
                                    IDBusinessCore: IDBusinessCore ?? null,
                                });
                            }}
                            returnType="Object"
                        />
                    </div>
                    <div className="col-md-6">
                        <label className={`${isMissing("IDBusinessCore") ? "has-error" : ""}`}>Linea de Negocio {isRequired("IDBusinessCore") ? <span className="text-danger">*</span> : ""}</label>
                        <SelectBusinessCore returnType="ID" idSelector={bean.IDBusinessCore} label=" " onChange={(e) => { setBean({ ...bean, IDBusinessCore: e }) }} />
                    </div>
                </>
            }

            <div className="col-md-6">
                <label className={`${isMissing("IDAccountSupplier") ? "has-error" : ""}`}>Proveedor {isRequired("IDAccountSupplier") ? <span className="text-danger">*</span> : ""}</label>
                <AccountEditor idAccount={bean.IDAccountSupplier} label=" " onChange={(e) => { setBean({ ...bean, IDAccountSupplier: e.IDAccount }) }} />
            </div>

            {bean.IDAccountSupplier &&
                <div className="col-md-6">
                    <label className={`${isMissing("IDThirdBankingAccount") ? "has-error" : ""}`}>Destino de Pago {isRequired("IDThirdBankingAccount") ? <span className="text-danger">*</span> : ""}</label>
                    <ThirdBankingAccountEditor label=" " idSelector={bean.IDThirdBankingAccount} idselectorAccount={bean.IDAccountSupplier} onChange={(e) => { setBean({ ...bean, IDThirdBankingAccount: e }) }} />
                </div>
            }

            <div className="col-md-6">
                <label className={`${isMissing("IDAccountantConcept") ? "has-error" : ""}`}>Concepto de Ingreso {isRequired("IDAccountantConcept") ? <span className="text-danger">*</span> : ""}</label>
                <SelectAccountantConceptCatalogForSupplierInvoice label=" " idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, IDAccountantConcept: e }) }} />
            </div>

            <div className="col-md-6">
                <label>Numero de la Factura de Proveedor</label>
                <input type="text" className="form-control" value={bean.InvoiceID ?? ""} onChange={(e) => { setBean({ ...bean, InvoiceID: e.target.value }) }} />
            </div>

            <div className="col-md-6">
                <BasicSwitch estado={bean.IsDocumentSupport} eventChange={(e) => { setBean({ ...bean, IsDocumentSupport: e }) }} label="Documento Fisico" />
            </div>

            <div className="col-md-6">
                <label className={`${isMissing("IssueDate") ? "has-error" : ""}`}>Fecha Remision {isRequired("IssueDate") ? <span className="text-danger">*</span> : ""}</label>
                <InputDate label=" " name="date" value={bean.IssueDate} setDate={(e) => { setBean({ ...bean, IssueDate: e }) }} />
            </div>

            <div className="col-md-6">
                <FileInput
                    onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext }) }}
                    Media={bean.Media}
                    MediaContext={bean.MediaContext}
                />
            </div>

            <div className="col-md-12">
                <label>Observaciones</label>
                <textarea className="form-control" value={bean.Observations ?? ""} onChange={(e) => { setBean({ ...bean, Observations: e.target.value }) }}></textarea>
            </div>
        </div>
    );

    const { listButtons: ublInvoiceActionButtons, actionModals: ublInvoiceActionModals, head: ublInvoiceHead } = useUBLInvoiceActions({
        invoice: bean,
        canView: _single.canView(),
        canDelete: _single.canDelete(),
        onChange: () => _onChange2?.(bean),
        useSupplierPaymentType: true,
        onEdit: openEditModal,
    });

    const iconButtonsItem = [
        { nombre: "Crear", visible: _single.canCreate(), icono: "ri-file-add-line", evento: openCreateModal },
    ];

    return (
        <>
            <BasicTable
                rowSet={setBean}
                listButtons={ublInvoiceActionButtons}
                head={ublInvoiceHead}
                body={lista}
                iconButtons={iconButtonsItem}
            />

            <Modal
                modal={modalForm.modal}
                updateModal={modalForm.setModal}
                eventModal={validateData}
                onSubmitLabel={bean.IDUBLInvoice ? "Actualizar" : "Crear"}
            >
                {formUBL()}
            </Modal>

            {ublInvoiceActionModals}
        </>
    );
};
